import React from 'react';
import { SkeletonFrame, SkeletonFrameProps } from './styled';

export const SkeletonText: React.FC<SkeletonFrameProps> = props => {
  return <SkeletonFrame {...props} />;
};
